import { query } from '@angular/animations';
import { DataLoader } from 'src/app/services/data-loader/data-loader';
import { XYChartAxis } from 'src/app/utils/echarts/xy-chart-axis';

export const createCase11b = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        // wait
        await new Promise((resolve) => setTimeout(resolve, 1000));

        const data = [
            {
                split_group: 'App Store',
                date: '2026-01-12',
                wavg_ARPDAU_net_pln: 0.53,
            },
            {
                split_group: 'App Store',
                date: '2026-01-13',
                wavg_ARPDAU_net_pln: 0.35,
            },
            {
                split_group: 'App Store',
                date: '2026-01-14',
                wavg_ARPDAU_net_pln: 0.05,
            },
            {
                split_group: 'App Store',
                date: '2026-01-15',
                wavg_ARPDAU_net_pln: 0.04,
            },
            {
                split_group: 'App Store',
                date: '2026-01-16',
                wavg_ARPDAU_net_pln: 0.36,
            },
            {
                split_group: 'App Store',
                date: '2026-01-17',
                wavg_ARPDAU_net_pln: 1.77,
            },
            {
                split_group: 'App Store',
                date: '2026-01-24',
                wavg_ARPDAU_net_pln: null,
            },
            {
                split_group: 'App Store',
                date: '2026-01-25',
                wavg_ARPDAU_net_pln: 1.04,
            },
            {
                split_group: 'App Store',
                date: '2026-03-27',
                wavg_ARPDAU_net_pln: null,
            },
            {
                split_group: 'App Store',
                date: '2026-03-28',
                wavg_ARPDAU_net_pln: 0.33,
            },
            {
                split_group: 'App Store',
                date: '2026-03-29',
                wavg_ARPDAU_net_pln: 0.67,
            },
            {
                split_group: 'App Store',
                date: '2026-03-30',
                wavg_ARPDAU_net_pln: 0.46,
            },
            {
                split_group: 'App Store',
                date: '2026-03-31',
                wavg_ARPDAU_net_pln: 0.19,
            },
            {
                split_group: 'App Store',
                date: '2026-04-01',
                wavg_ARPDAU_net_pln: 1.03,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-13',
                wavg_ARPDAU_net_pln: 0,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-14',
                wavg_ARPDAU_net_pln: 0.09,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-15',
                wavg_ARPDAU_net_pln: 0.21,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-16',
                wavg_ARPDAU_net_pln: 0.34,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-17',
                wavg_ARPDAU_net_pln: 0.26,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-18',
                wavg_ARPDAU_net_pln: 0.46,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-19',
                wavg_ARPDAU_net_pln: 0.19,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-20',
                wavg_ARPDAU_net_pln: 0.19,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-21',
                wavg_ARPDAU_net_pln: 0.26,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-22',
                wavg_ARPDAU_net_pln: 0.22,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-23',
                wavg_ARPDAU_net_pln: 0.26,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-24',
                wavg_ARPDAU_net_pln: 0.19,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-25',
                wavg_ARPDAU_net_pln: 0.13,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-26',
                wavg_ARPDAU_net_pln: 0.16,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-27',
                wavg_ARPDAU_net_pln: 0.19,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-28',
                wavg_ARPDAU_net_pln: 0.24,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-29',
                wavg_ARPDAU_net_pln: 0.24,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-30',
                wavg_ARPDAU_net_pln: 0.17,
            },
            {
                split_group: 'Google Play',
                date: '2026-03-31',
                wavg_ARPDAU_net_pln: 0.16,
            },
            {
                split_group: 'Google Play',
                date: '2026-04-01',
                wavg_ARPDAU_net_pln: 0.19,
            },
        ];
        queryContext.settings.datetimeAggregation = 'day';
        queryContext.datasourceColumns = [
            {
                id: 'FIREBASE_APP_STORE',
                state: {
                    value: {
                        options: [],
                        filterType: 'include',
                    },
                    isFilterApplied: false,
                    isSplitApplied: true,
                },
            },
        ];

        XYChartAxis.fillMissingTimeGapRows(data, queryContext, 'date', 'day');

        this.emitter.emit({
            data,
            queryContext: queryContext,
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
